import theme from '../styles/themes/default';

export const checkToFormatLicensingStatus = (vehicle: any) => {
  return {
    color:
      vehicle.uf === 'SE'
        ? theme.colors.gray[500]
        : vehicle.licensingStatus === 'LICENSED'
        ? theme.colors.succesful
        : vehicle.licensingStatus === 'NOT_LICENSED'
        ? theme.colors.attention
        : vehicle.licensingStatus === 'AVALIABLE_FOR_LICENSING'
        ? theme.colors.yellow.text
        : vehicle.licensingStatus === 'UNDEFINED'
        ? theme.colors.green.primary
        : theme.colors.gray[900],
    label:
      vehicle.uf === 'SE'
        ? '--'
        : vehicle.licensingStatus === 'LICENSED'
        ? 'Em dia'
        : vehicle.licensingStatus === 'NOT_LICENSED'
        ? 'Atrasado'
        : vehicle.licensingStatus === 'AVALIABLE_FOR_LICENSING'
        ? 'A pagar'
        : '--',
  };
};
